import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Form } from 'components/Form/Form/Form';
import RefereeFormWrapper from 'components/Form/RefereeForm/RefereeFormWrapper';

export const FormPreviewModal = ({ form, visible, useModernForm = false, onClose = () => {} }) => {
  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={useModernForm ? '' : form.name}
      className="u-margin-y--large"
      small={useModernForm ? false : true}
      fullscreen={useModernForm}>
      {visible &&
        (useModernForm ? (
          <RefereeFormWrapper
            questions={form?.fields}
            logicJumps={form?.logic_jumps}
            disabled={visible}
          />
        ) : (
          <Form form={form} buttonTitle="Close" onSubmit={onClose} disabled={visible} />
        ))}
    </AnimatedModal>
  );
};
